module.exports = __webpack_public_path__ + "img/chevron-bar-expand.96a7fdac.svg";